import { ArtifactOptions } from "../../types";
import { addBodyIfNone } from "../../Artifacts/PageBuilderArtifact";
import { BODY_ID, EditorMode } from "@/Apps/Pages/Editor/types";
import { PageArtifactContainer } from "./PageArtifactContainer";

import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import { useState } from "react";
import { PageContent } from "@/Apps/Pages/Page/Page";
import { cleanThisContent } from "@/Apps/Pages/V2Editor/actions";
import PureCanvas from "@/Apps/Pages/V1Editor/PureCanvas";
import { MobileState } from "@/Apps/Pages/MobileResponsiveToggle/types";

export const ChangedComponentTool = ({
  content = "",
  intention = "",
  artifactOptions = {},
  diff = [],
  onClick = () => {},
  setArtifactOptions = () => {},
}: {
  content: string;
  intention: string;
  diff: any;
  onClick: () => void;
  setArtifactOptions: (options: ArtifactOptions) => void;
}) => {
  // return null;
  const [isExpanded, setIsExpanded] = useState(false);

  const diffContent = diff[0]?.value;
  const pageContent = addBodyIfNone(
    cleanThisContent([
      {
        ...diffContent,
        parent: diffContent?.parent === "root" ? BODY_ID : diffContent?.parent,
      },
    ])
  );

  return (
    <div
      onClick={onClick}
      className={`
        border border-black/10 dark:border-white/10 rounded-md p-3 
        shadow-sm bg-black/5 dark:bg-white/5 cursor-pointer 
        hover:bg-transparent dark:hover:bg-transparent transition-all 
        duration-300 max-w-md ${isExpanded ? "bg-black/10 dark:bg-white/10" : ""}
        `}
    >
      <p
        onClick={() => {
          if (intention !== "DELETE_COMPONENT") {
            setIsExpanded(!isExpanded);
          }
        }}
        className="text-sm flex items-center gap-2 cursor-pointer justify-start"
      >
        {intention !== "DELETE_COMPONENT" ? (
          <span className="text-xs text-gray-500">
            {isExpanded ? "▼" : "▶"}
          </span>
        ) : (
          <span className="text-sm">🛠</span>
        )}
        {content}
      </p>
      {isExpanded && diffContent && (
        <div className="text-sm p-2 mt-2 max-h-[150px] overflow-y-hidden bg-white rounded-md">
          <div className="scale-75">
            {/* {JSON.stringify(pageContent)} */}
            {/* <PageContent id={""} content={JSON.stringify(pageContent)} /> */}
            <DndProvider backend={HTML5Backend}>
              <PureCanvas
                content={pageContent}
                mobileState={{ type: MobileState.FULLSCREEN }}
                mode={EditorMode.LIVE}
              />
            </DndProvider>
          </div>
        </div>
      )}
    </div>
  );
};
